import React, { useMemo } from 'react';
import TanStackTable from '../../../../../../../shared/design-system/ui/tanstack-table';
import { PaginationOptionsChangePayload } from '../../../../../../../shared/design-system/ui/tanstack-table/types';
import { getVoicemailTemplatesColumnDefinitions } from './column-definitions';
import './voicemail-templates-table.scss';
import { Template } from '../../../../../types';

interface IProps {
  data: Template[];
  isLoading?: boolean;
  page: number;
  limit: number;
  totalRows: number;
  onPaginationChange?: (payload: PaginationOptionsChangePayload) => void;
  onEditTemplate?: (template: Template) => void;
  onDeleteTemplate?: (template: Template) => void;
  resetGetSignedUrlForVoicemailTemplateRequest?: () => void;
  setSelectedTemplateId?: (id: number | null) => void;
  selectedTemplateId?: number | null;
}

const VoicemailTemplatesTable: React.FC<IProps> = ({
  data = [],
  isLoading = false,
  page,
  limit,
  totalRows,
  onPaginationChange,
  onEditTemplate,
  onDeleteTemplate,
  resetGetSignedUrlForVoicemailTemplateRequest,
  setSelectedTemplateId,
  selectedTemplateId,
}) => {
  const pinnedColumns = useMemo(() => ['title'], []);
  const columns = useMemo(
    () =>
      getVoicemailTemplatesColumnDefinitions({
        onEditTemplate,
        onDeleteTemplate,
        resetGetSignedUrlForVoicemailTemplateRequest,
        setSelectedTemplateId,
        selectedTemplateId,
      }),
    [
      onEditTemplate,
      onDeleteTemplate,
      resetGetSignedUrlForVoicemailTemplateRequest,
      setSelectedTemplateId,
      selectedTemplateId,
    ],
  );
  const paginationOptions = useMemo(
    () => ({
      page,
      limit,
      totalRows,
      onPaginationOptionsChange: onPaginationChange,
    }),
    [page, limit, totalRows, onPaginationChange],
  );

  const paginationSizeOptions = useMemo(() => [25, 50, 75, 100], []);

  return (
    <div className="voicemail-templates-table">
      <TanStackTable<Template>
        columns={columns}
        rows={isLoading ? [] : data}
        isLoading={isLoading}
        paginationOptions={paginationOptions}
        paginationSizeOptions={paginationSizeOptions}
        pinnedColumns={pinnedColumns}
        enableSorting={true}
        enableRowSelection={false}
        itemName="template"
        tableClassName="voicemail-templates-tanstack-table"
        enableColumnResizing={false}
        rightPinnedColumns={['actions']}
      />
    </div>
  );
};

export default VoicemailTemplatesTable;
